import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'

export const useStyles = makeStyles()(() => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    minWidth: 0,
  },
  fullWidth: {
    gridColumn: '1 / -1',
  },
  label: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.labelText,
  },
  valueRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },
  value: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.darkText,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  copy: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    flexShrink: 0,
    '& svg': { fontSize: 13, color: C.mutedText },
  },
}))
